import ArchiveService from "@/services/archivesummary.service";

const state= {
    archiveConceptList: [],
    archiveAnalytics: []
};

const mutations = {
    set_ArchiveConcept(state, payload) {
        state.archiveConceptList = payload;
    },
    clear_ArchiveConcept(state) {
        state.archiveConceptList = [];
    },

    set_archiveAnalytics(state, payload) {
        state.archiveAnalytics = payload;
    },
    clear_archiveAnalytics(state) {
        state.archiveAnalytics = [];
    },
};

const actions = {

    async getArchiveConceptListM({commit},payload){
        commit("clear_ArchiveConcept");

        const archiveConcept =await ArchiveService.getArchiveConcept(payload);
        commit("set_ArchiveConcept", archiveConcept);
        return archiveConcept;
    },

    async getArchiveTransferAnalytics({commit},payload){
        commit("clear_archiveAnalytics");

        const archiveAnalyticsData = await ArchiveService.getDashboardAnalytics(payload);
        commit("set_archiveAnalytics", archiveAnalyticsData);
        return archiveAnalyticsData;
    }

};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
